const focalDimensionRegex = /(\d*)x(\d*)/;

const fitDimensionRegex = /fit-(\d*)w/;

const focalDimensionReplace = (flavor) => (width, height) => flavor.replace(focalDimensionRegex, `${width}x${height}`);

const fitDimensionReplace = (flavor) => (width) => flavor.replace(fitDimensionRegex, `fit-${width}w`);


export const getTelemundoImageSrc = (originalSource, flavor) => {
  const newSource = originalSource
    .replace(/sites\/nbcutelemundo\/files/, `sites/nbcutelemundo/files/styles/${flavor}/public`);
  return `${newSource}?ramen_itok=iqwQftIcTf`;
};

/**
 * @param String flavor
 */
export const getWidthAndHeightFromAIMSFlavor = (flavor) => {
  if (typeof flavor === 'string') {
    const focalResult = flavor.match(focalDimensionRegex);
    if (focalResult) {
      const [, width, height] = focalResult;
      return {
        height,
        width,
        replace: focalDimensionReplace(flavor),
      };
    }

    const fitResult = flavor.match(fitDimensionRegex);
    if (fitResult) {
      const [, width] = fitResult;
      const height = width; // Responsive - see fit AIMS definitions
      return {
        height,
        width,
        replace: fitDimensionReplace(flavor),
      };
    }

    return {};
  }
  return {};
};

export const IMAGE_SIZES = [
  's',
  'm',
  'l',
  'xl',
];

export default {
  IMAGE_SIZES,
  getTelemundoImageSrc,
  getWidthAndHeightFromAIMSFlavor,
};
